var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Autocomplete, Box, CircularProgress, MenuItem, TextField, Typography } from '@mui/material';
import React from 'react';
const mapToDropdownOption = (option, level) => ({
    label: option.text,
    value: option.value,
    level: level,
});
export const ProfileScopeMenuItem = (_a) => {
    var { selectedValue, selectedText, label, options, onProfileScopeChange } = _a, restProps = __rest(_a, ["selectedValue", "selectedText", "label", "options", "onProfileScopeChange"]);
    const [open, setOpen] = React.useState(false);
    const [comboBoxOptions, setComboBoxOptions] = React.useState([]);
    const [value, setValue] = React.useState({ label: selectedText, value: selectedValue !== null && selectedValue !== void 0 ? selectedValue : '', level: 0 });
    const loading = open && comboBoxOptions.length === 0;
    React.useEffect(() => {
        let active = true;
        if (!loading) {
            return undefined;
        }
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const optionsList = options ? yield options() : [];
            if (active) {
                setComboBoxOptions(optionsList.flatMap((x) => {
                    var _a;
                    return ((_a = x.subOptions) === null || _a === void 0 ? void 0 : _a.length)
                        ? [mapToDropdownOption(x, 0), ...x.subOptions.map((c) => mapToDropdownOption(c, 1))]
                        : mapToDropdownOption(x, 0);
                }));
            }
        }))();
        return () => {
            active = false;
        };
    }, [loading, options]);
    React.useEffect(() => {
        if (!open) {
            setComboBoxOptions([]);
        }
    }, [open]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const menuItemRef = React.useRef();
    const [inputFocus, setInputFocus] = React.useState(false);
    const inputRef = React.useRef();
    return (React.createElement(MenuItem, { ref: menuItemRef, disableTouchRipple: true, sx: {
            display: 'flex',
            flexDirection: 'column',
            p: 2,
            '&.Mui-focusVisible': {
                backgroundColor: inputFocus ? 'transparent' : undefined,
            },
        }, onKeyDown: (event) => {
            var _a, _b, _c;
            if (inputFocus) {
                if (event.key === 'Enter' || event.key === 'Escape') {
                    (_a = menuItemRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }
                event.stopPropagation();
            }
            else {
                if (event.key === 'Enter') {
                    (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.focus();
                    (_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.select();
                }
            }
        }, onClick: () => {
            var _a, _b;
            if (!inputFocus) {
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.select();
            }
        } },
        React.createElement(Autocomplete, { fullWidth: true, openOnFocus: true, selectOnFocus: true, value: value, open: open, onOpen: () => {
                setOpen(true);
            }, onChange: (event, newValue) => {
                if (newValue) {
                    setValue(newValue);
                    onProfileScopeChange === null || onProfileScopeChange === void 0 ? void 0 : onProfileScopeChange({ text: newValue.label, value: newValue.value, subOptions: [] });
                }
            }, onClose: () => {
                setOpen(false);
            }, isOptionEqualToValue: (option, value) => option.value === value.value, options: comboBoxOptions, getOptionKey: (option) => option.value, loading: loading, renderOption: (renderProps, option) => (React.createElement(Typography, Object.assign({}, renderProps, { component: 'li' }),
                React.createElement(Box, { component: 'div', pl: option.level * 2, pt: 1, pb: 1 }, option.label))), renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { inputRef: inputRef, label: label, InputProps: Object.assign(Object.assign({}, params.InputProps), { endAdornment: (React.createElement(React.Fragment, null,
                        loading ? React.createElement(CircularProgress, { color: 'inherit', size: 20 }) : null,
                        params.InputProps.endAdornment)) }) }))), onFocus: () => {
                setInputFocus(true);
            }, onBlur: () => {
                setInputFocus(false);
            }, "data-test": restProps['data-test'] })));
};
